import type { FC, ReactNode } from 'react'

import { MARQUEE_ITEMS } from '@/constants/landing'

export const MarqueeBand: FC = (): ReactNode => {
    return (
        <section aria-label="The house at a glance" className='relative overflow-hidden bg-espresso py-7 text-ivory'>
            <div className='flex w-max motion-safe:animate-marquee'>
                {[0, 1].map((copy) => (
                    <ul key={copy} aria-hidden={copy === 1} className='flex shrink-0 items-center'>
                        {MARQUEE_ITEMS.map((item) => (
                            <li
                                key={item}
                                className='flex items-center gap-10 pr-10 font-heading text-2xl font-light italic text-ivory/90 sm:text-3xl'
                            >
                                {item}
                                <span aria-hidden='true' className='size-1.5 rotate-45 bg-gold' />
                            </li>
                        ))}
                    </ul>
                ))}
            </div>

            <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 left-0 w-24 bg-linear-to-r from-espresso to-transparent' />
            <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 right-0 w-24 bg-linear-to-l from-espresso to-transparent' />
        </section>
    )
}
